export const setupPlayer = `
<div class="player-name">Prepare your fleet</div>
<div class="input">
  <label for="player">Name your fleet</label>
  <input type="text" name="player" id="player" />
</div>
<div>
<div>Right click to rotate a ship</div>
<div>Drag and drop to place ships</div>
</div>
<div class="fleet"></div>
<div class="buttons">
  <button id="random">Random</button>
  <button id="clear">Clear</button>
  <button type="submit" id="start" class="inactive" >Start game</button>
</div>

`;
